import { LocalParticipant as OfficialTwilioLocalParticipant } from 'twilio-video';

import { LocalParticipant } from '../../../core/room/participant/LocalParticipant';
import { NetworkQualityChangeHandler } from '../../../core/room/participant/types';
import { parseIdentity } from '../../../core/room/participant/utils';

export class TwilioLocalParticipant implements LocalParticipant {
  #participant: OfficialTwilioLocalParticipant;

  constructor(participant: OfficialTwilioLocalParticipant) {
    this.#participant = participant;
  }

  get sid() {
    return this.#participant.sid;
  }

  get identity() {
    return this.#participant.identity;
  }

  get displayName(): string {
    const { identity } = this.#participant;
    return parseIdentity(identity)?.name ?? 'Participant';
  }

  on(event: 'networkQualityLevelChanged', handler: NetworkQualityChangeHandler) {
    this.#participant.on(event, handler);

    return () => {
      this.#participant.off(event, handler);
    };
  }
}
